import { render, staticRenderFns } from "./PretragaRezervnihDelova.vue?vue&type=template&id=0b34f992&"
import script from "./PretragaRezervnihDelova.vue?vue&type=script&lang=ts&"
export * from "./PretragaRezervnihDelova.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports